import { render } from "./NotificationCard.vue?vue&type=template&id=153746f2&scoped=true"
import script from "./NotificationCard.vue?vue&type=script&lang=js"
export * from "./NotificationCard.vue?vue&type=script&lang=js"

import "./NotificationCard.vue?vue&type=style&index=0&id=153746f2&scoped=true&lang=css"
import "./NotificationCard.vue?vue&type=style&index=1&id=153746f2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-153746f2"]])

export default __exports__